























import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { Auth } from "@/mixins/auth";

@Component
export default class CleanHeader extends mixins(Auth) {}
